import { Formik } from 'formik';
import * as React from 'react';
import AutodeskBranding from './AutodeskBranding';
import * as Styled from './LoginWrapper.styles';
import MainFooter from './MainFooter';
/**
 * A wrapper component for the login page.
 */
export const LoginWrapper = ({ children, validationSchema, initialValues, }) => {
    return (React.createElement(Formik, { onSubmit: () => undefined, initialValues: initialValues, validationSchema: validationSchema }, () => (React.createElement(Styled.Wrapper, null,
        React.createElement(Styled.Main, null,
            React.createElement(Styled.MainBody, null, children),
            React.createElement(MainFooter, null)),
        React.createElement(AutodeskBranding, null)))));
};
LoginWrapper.defaultProps = {
    children: '',
};
export default LoginWrapper;
